(function ($) {
    $.fn.newsRestGesica = function () {
        var that = this;
        var container = $(this).find('.js-news').first();
        var category = that.data('category');
        var firmId = that.data('firm-id');
        var apiUrl = that.data('api-url');
        var search;
        var template = null;
        var nextUrl = null;

        var args = {
            'posts_per_page': 6,
            'page': 0,
            'category__slug': category,
        }
        var params = {}
        var $select = $('.js-filter-select');

        function hideButton() {
            $('.js-load-more').addClass('hide');
        }

        function showButton() {
            $('.js-load-more').removeClass('hide');
        }

        $('.js-load-more').on('click', function () {
            args.page = args.page + 1;
            getNews(false);
        })

        $('.js-filter').on('click', function (e) {
            nextUrl = null
            $('.js-filter').removeClass('is-active');
            $(e.target).addClass('is-active');
            delete params['date']; 
            delete params['category__slug']; 
            params = Object.assign(params, e.target.dataset.gesica ? {
                'is_gesica': e.target.dataset.gesica == 1 ? true : false,
            } : {});
            getCategories(e.target.dataset.gesica);
            getDates(e.target.dataset.gesica);
            getNews(true);         
        })

        $select.on('change', function(e) {
            var el = e.target;
            var args = {};
            args[el.id] = $(el).val();
            nextUrl = null;
            params = Object.assign(params, args);
            getNews(true);
        })
        
        $('.js-input-search').on('click', function() {
            search = $("#input-search").val();
            nextUrl = null;
            params = Object.assign(params, {'search': search});
            getNews(true);
        })

        function getCategories(is_gesica) {
            $.ajax({
                type: 'GET',
                url: apiUrl + "articles/" + firmId + "/minisite-categories",
                data: {"is-gesica": is_gesica},
                success: function (res) {
                    $('.js-filter-select-categories').html('');
                    createOptionsCategories(res);
                }
            })
        };

        function getDates(is_gesica) {
            $.ajax({
                type: 'GET',
                url: apiUrl + "articles/" + firmId + "/minisite-dates",
                data: {"is-gesica": is_gesica},
                success: function (res) {
                    $('.js-filter-select-dates').html('');
                    createOptionsDates(res);
                }
            })
        };

        function createOptionsDates(dates) {
            var firstOption = document.createElement("option");
            var firstContent = document.createTextNode("Choisir un mois");
            firstOption.appendChild(firstContent);
            $('.js-filter-select-dates').append(firstOption);
            for (var key in dates){
                var newOption = document.createElement("option");
                var attr = document.createAttribute("value");
                attr.value = dates[key];
                newOption.setAttributeNode(attr);
                var newContent = document.createTextNode(key);
                newOption.appendChild(newContent);
                $('.js-filter-select-dates').append(newOption);
            }
        }

        function createOptionsCategories(categories) {
            var firstOption = document.createElement("option");
            var firstContent = document.createTextNode("Choisir une catégorie");
            firstOption.appendChild(firstContent);
            $('.js-filter-select-categories').append(firstOption);

            categories.forEach(function(category) {
                var newOption = document.createElement("option");
                var attr = document.createAttribute("value");
                attr.value = category.slug;
                newOption.setAttributeNode(attr);  
                var newContent = document.createTextNode(category.name);
                newOption.appendChild(newContent);
                
                $('.js-filter-select-categories').append(newOption);
            });
        }

        function getNews(replace) {
            that.addClass('is-loading')
            if (replace) {
                container.html('');
            }
            var filter = $('#only-ajis')
            if (filter.length) {
                params = Object.assign(params, {"is_gesica": false});
            }
            if (that.data('posts')) {
                params = Object.assign(params, {
                    "is_gesica" : 1,
                    "is_section": true 
                });
            }
            $.ajax({
                type: 'GET',
                url: nextUrl ? nextUrl : apiUrl + "articles/" + firmId + "/minisite",
                data: params,
                success: function (res) {
                    nextUrl = res.next;
                    var items = res.results;
                    items.map(function(item) {
                        item.published_date = getDate(item.published_date),
                        item.video_id = item.video_id != '' ? item.video_id : null
                    })
                    $.get({
                        url: '/wp-content/themes/5x5/templates/news.html',
                        success: function (html) {
                            template = Handlebars.compile(html);

                            items = template({
                                items: items
                            })
                            if (nextUrl) {
                                showButton();
                            } else {
                                hideButton();
                            }
                            container.append(items);
                            that.removeClass('is-loading')
                            setIntersections();
                            initToShow();
                        },
                        error: function (err) {
                            console.log(err);
                        }
                    })
                },
            })
        }
        getNews(true);
        getCategories("1");
        getDates("1");
    }
}(jQuery));

$(function () {
    if ($('#js-news').length) {
        $('#js-news').newsRestGesica();
    }
});
